// ============================================================================
// AppModule - Root Application Module
// ============================================================================
// Bootstraps the app with PrimeNG (Lara theme), global error handler, and the
// shell layout components (header, left nav, right panel). Imports CoreModule
// for singletons and SharedModule for common UI. Replaces V1's app.js bootstrap.
// ============================================================================

import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GlobalErrorHandler } from './core/error-handler.service';
import { TenantService } from './core/tenant.service';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppRoutingModule } from './app.router';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { ShellComponent } from './layout/shell.component';
import { HeaderComponent } from './layout/header/header.component';
import { LeftNavComponent } from './layout/left-nav/left-nav.component';
import { RightPanelComponent } from './layout/right-panel/right-panel.component';
import { BreadcrumbComponent } from './layout/breadcrumb/breadcrumb.component';
import { UploadStatusComponent } from './layout/upload-status/upload-status.component';

@NgModule({
  declarations: [
    AppComponent,
    ShellComponent,
    HeaderComponent,
    LeftNavComponent,
    RightPanelComponent,
    BreadcrumbComponent,
    UploadStatusComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule.forRoot(),
    SharedModule,
    AppRoutingModule
  ],
  providers: [
    providePrimeNG({
      theme: {
        preset: Lara,
        options: {
          darkModeSelector: false
        }
      }
    }),
    MessageService,
    ConfirmationService,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    // Resolve the server's tenant before any component renders. Falls back
    // silently to hostname-based detection if /api/tenant is unreachable.
    {
      provide: APP_INITIALIZER,
      useFactory: (tenant: TenantService) => () => tenant.init(),
      deps: [TenantService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
